import { darken } from '@material-ui/core'
import makeStyles from '@material-ui/core/styles/makeStyles'

const useStyles = makeStyles((theme) => ({
  tableRow: {
    display: 'grid',
    gridTemplateColumns: '3fr 1fr',
    paddingTop: 20,
    paddingBottom: 20,
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    borderRadius: 20,
    cursor: 'pointer',
    paddingLeft: 12,
    paddingRight: 7,
    transition: 'background-color 0.3s ease-in-out',
    width: '100%',
    textAlign: 'unset',
    '&:hover': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? darken(theme.palette.background.default, 0.3)
          : '#f0f0f0'
    }
  },
  nameCell: {
    display: 'flex'
  },
  circularProgress: {
    marginLeft: 8,
    color: theme.palette.primary.main
  },
  cursorDefault: {
    cursor: 'default'
  }
}))
export default useStyles
